import { DeleteOutlined, HolderOutlined, PlusOutlined } from '@ant-design/icons';
import { Col, Input, Row, Select, Space } from 'antd';
import Typography from 'antd/es/typography/Typography';
import { Draggable, Droppable } from 'react-beautiful-dnd';

import DraggableSerieCard from './DraggableSerieCard';

const { Title } = Typography;

const RowCategory = props => {
  const { index, onAddCollection, onAddSerie, onChangeContentType, onChangeImgType, onDeleteCat, onDeleteSerie, section, types } =
    props;

  const captureOnDeleteSerie = indexSerie => {
    if (onDeleteSerie) onDeleteSerie(index, indexSerie);
  };

  const AddSerie = props => {
    const { type } = props;
    return (
      <div
        style={{
          backgroundColor: '#00cca3',
          borderRadius: 100,
          cursor: 'pointer',
          margin: 30,
          padding: 40,
        }}
        onClick={() => {
          if (type === 'serie') onAddSerie(index);
          else onAddCollection(index);
        }}>
        <PlusOutlined style={{ color: '#120D35', fontSize: 20 }} />
      </div>
    );
  };

  return (
    <Draggable draggableId={`${section.uid}`} index={index}>
      {provided => {
        return (
          <div {...provided.draggableProps} ref={provided.innerRef}>
            <div
              style={{
                backgroundColor: '#2B1A59',
                borderRadius: 10,
                padding: 12,
              }}>
              <Row {...provided.dragHandleProps} gutter={10}>
                <Col
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  span={2}>
                  <HolderOutlined style={{ color: 'white', fontSize: 20 }} />
                </Col>
                <Col span={10}>
                  <Input
                    id={`section-name-${section.uid}`}
                    placeholder="Nom de la section"
                    defaultValue={section.name}
                    maxLength={255}
                  />
                </Col>
                <Col span={5}>
                  <Select
                    defaultValue={section.ImgType.idTypeImg}
                    style={{ width: '100%' }}
                    options={types.map(t => {
                      return { label: t.nameType, value: t.idTypeImg };
                    })}
                    onChange={value => {
                      onChangeImgType(index, value);
                    }}
                  />
                </Col>
                <Col span={5}>
                  <Select
                    defaultValue={section.typeContent}
                    style={{ width: '100%' }}
                    options={[
                      { label: 'Serie', value: 'serie' },
                      { label: 'Collection', value: 'collection' },
                      { label: "Maison d'édition", value: 'maison_edition' },
                    ]}
                    onChange={value => {
                      onChangeContentType(index, value);
                    }}
                  />
                </Col>
                <Col
                  style={{
                    alignItems: 'center',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                  span={2}
                  onClick={() => {
                    onDeleteCat(index);
                  }}>
                  <DeleteOutlined style={{ color: 'white', fontSize: 20 }} />
                </Col>
              </Row>
              {section.imgType === 6 ? (
                <Row>
                  <Col span={5}>
                    <Title style={{ color: 'white' }} level={5}>
                      Sous-titre
                    </Title>
                    <Input
                      id={`section-subtitle-${section.uid}`}
                      placeholder="Sous-titre"
                      defaultValue={section.subtitle}
                      maxLength={255}
                    />
                  </Col>
                </Row>
              ) : null}

              <Droppable direction="horizontal" droppableId={`${section.uid}`} type="task">
                {provided => {
                  return (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      <div style={{ marginTop: 20, overflow: 'scroll' }}>
                        <Space
                          style={{
                            flexGrow: 1,
                            minHeight: '100px',
                          }}
                          direction="horizontal">
                          <AddSerie
                            key={`add-serie-card`}
                            index={section.content.length}
                            draggableId={`add-serie-card`}
                            type={section.imgType === 7 ? 'collection' : 'serie'}
                          />
                          {section.content.map((serie, i) => {
                            return (
                              <DraggableSerieCard
                                key={`${serie.uidV4 ? serie.uidV4 : serie.uid}-${section.uid}`}
                                serie={serie}
                                index={i}
                                draggableId={`${serie.uidV4 ? serie.uidV4 : serie.uid}-${section.uid}`}
                                imgType={section.imgType}
                                onDeleteSerie={captureOnDeleteSerie}
                              />
                            );
                          })}
                          {provided.placeholder}
                        </Space>
                      </div>
                    </div>
                  );
                }}
              </Droppable>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};

export default RowCategory;
